import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { PropertyDocumentModel } from '../models/PropertyDocumentModel';

@Component({
  selector: 'app-propertydocumentdetails',
  templateUrl: './propertydocumentdetails.component.html',
  styleUrls: ['./propertydocumentdetails.component.scss']
})
export class PropertydocumentdetailsComponent implements OnInit {

  public doc : PropertyDocumentModel;

  constructor(private data: DataService) {
    

   }

  ngOnInit(): void {

    this.doc = this.data.SelectedPropertyDocument;
  }

}
